import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/myDocuments/photocard/photocard"));

const PhotoCard = () => {
  return (
    <Layout pageHeading="My Documents">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default PhotoCard;
